import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import base64 from "base-64";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const getVendorProcessFee = createAsyncThunk(
  "app/getVendorProcessFee",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };

    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc-fee/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const updateVendorProcessFeePayment = createAsyncThunk(
  "app/updateVendorProcessFeePayment",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ ...data, pin: base64.encode(data.pin) });
      const res = await axios.put(`/api/proc-fee`, body, config);
      successAlertHandle("Action submitted successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getVendorProcessFeeDetailReport = createAsyncThunk(
  "app/getVendorProcessFeeDetailReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc-fee/detail/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getVendorProcessFeePaymentReport = createAsyncThunk(
  "app/getVendorProcessFeePaymentReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/proc-fee/payment/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const exportVendorProcessingFeeReport = async ({ filters, type }) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(`/api/download/${type}/filter`, body, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};
